<template>
    <div>
        <!--==============  menu-gallery  =============-->
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <a href="/#/"><img class="pt-lg-4" style="max-width: 28%" src="../assets/arrow-left-custom.svg" alt="arrow"></a>
                </div>
                <div class="col-lg-8">
                    <h1 class="text-left pl-lg-5 pt-lg-4 pb-lg-4">Reportáž</h1>
                </div>
            </div>
            <div id="menuPhoto" class="container">
                <div class="row text-center">
                    <div class="col-lg itemGallery text-center">
                        <router-link to="/svatba">Svatba</router-link>
                    </div>
                    <div class="col-lg offset-lg-1 itemGallery text-center">
                        <router-link to="/portrety">Portréty</router-link>
                    </div>
                    <div class="col-lg offset-lg-1 itemGallery text-center">
                        <router-link to="/reportaz">Reportáž</router-link>
                    </div>
                    <div class="col-lg offset-lg-1 itemGallery text-center">
                        <router-link to="/miminka">Miminka</router-link>
                    </div>
                </div>
                <div class="row text-center pt-lg-3">
                    <div class="col-lg itemGallery"><router-link to="/divadlo">Divadlo</router-link></div>
                    <div class="col-lg offset-lg-1 itemGallery text-center"><router-link to="/rodina">Rodina</router-link></div>
                    <div class="col-lg offset-lg-1 itemGalleryNone text-center"></div>
                    <div class="col-lg offset-lg-1 itemGalleryNone text-center"></div>
                </div>
            </div>
        </div>
        <!--==============  wedding img  =============-->
        <div id="gallery">
            <div class="container pt-lg-4">
                <div class="row text-center text-lg-left">
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img id="ImgNew" class="img-fluid img-thumbnail" src="/gallery/reportaz/0rp_imgmin.jpg"
                                 alt="reportaz">
                        </a>
                    </div>
                    <div id="myModal" class="modal">
                        <span class="close">&times;</span>
                        <img class="modal-content img-fluid" id="img01">
                        <div id="caption"></div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/1rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/2rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/3rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/4rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/5rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/6rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/7rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/8rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/9rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/10rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/11rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/12rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/13rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/14rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/15rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/16rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/17rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/18rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/19rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/20rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/21rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/22rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/23rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/24rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/25rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/26rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/27rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/28rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/29rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/30rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/31rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/33rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/34rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/35rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/36rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/37rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/38rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/39rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/40rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/41rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/42rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/43rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/44rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/45rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/46rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/47rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/48rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/49rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/50rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/51rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/52rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/53rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/54rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/55rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/56rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/57rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/58rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/59rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/60rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/61rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/62rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/63rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/64rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/65rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/66rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/67rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/68rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/69rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/70rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/71rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/72rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/73rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/74rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/75rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/76rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/77rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/78rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/79rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/80rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/81rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/82rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/83rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/84rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/85rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/86rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/87rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/88rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/89rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/90rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/91rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/92rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/93rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/94rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/95rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/96rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/97rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/98rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/99rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/100rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/101rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/102rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/103rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/104rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/105rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/106rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/107rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/108rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid img-thumbnail" src="/gallery/reportaz/109rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6">
                        <a href="#" class="d-block mb-4 h-100">
                            <img class="img-fluid" src="/gallery/reportaz/110rp_imgmin.jpg" alt="reportaz">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "svatba",
        data() {
            return {}
        },
        mounted() {
            // Get the modal
            let modal = document.getElementById("myModal");

// Get the image and insert it inside the modal - use its "alt" text as a caption
            if (document.getElementById("gallery") != null) {
                let images = document.getElementById("gallery").getElementsByTagName("img");
                Array.prototype.forEach.call(images, function (image) {
                    let modalImg = document.getElementById("img01");
                    let captionText = document.getElementById("caption");
                    image.onclick = function () {
                        modal.style.display = "block";
                        modalImg.src = image.src.replace("min", "full");
                        captionText.innerHTML = this.alt;
                    }
                });

// Get the <span> element that closes the modal
                let span = document.getElementsByClassName("close")[0];

// When the user clicks on <span> (x), close the modal
                span.onclick = function () {
                    modal.style.display = "none";
                }
            }
        },
        methods: {}
    }
</script>

<style scoped>
    h1 {
        padding-bottom: 2.5rem;
        padding-left: 15px;
        color: black;
        padding-top: 10px;
        font-size: 3.5rem;
    }
    .img-thumbnail {
        border: none;
    }
    #menuPhoto a {
        color: white;
        background-color: black;
        border: solid 2px black;
        padding: 4px 2em 5px 2em;
        font-size: 30px;
        min-width: 7.1em;
        text-decoration: none;
    }
    #menuPhoto a:hover {
        color: #000000;
        background-color: white;
        border: solid 2px black;
        padding: 4px 2em 5px 2em;
        font-size: 30px;
        min-width: 7.1em;
    }

    .itemGalleryActive {
        color: black;
        background-color: white;
        border: solid 2px black;
        padding: 0px 0px 2px 0px;
        font-size: 30px;
        min-width: 7.1em;
        text-decoration: none;
    }

    .itemGalleryNone {
        color: white;
        background-color: white;
        min-width: 7.1em;
    }

    .itemGalleryNone:hover {
        color: white;
        background-color: white;
        min-width: 7.1em;
    }

    /*============galllery===============*/


    #myImg {
        cursor: pointer;
        transition: 0.3s;
    }

    #myImg:hover {
        opacity: 0.7;
    }

    /* The Modal (background) */
    .modal {
        display: none; /* Hidden by default */
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        padding-top: 100px; /* Location of the box */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0, 0, 0); /* Fallback color */
        background-color: rgba(0, 0, 0, 0.9); /* Black w/ opacity */
    }

    /* Modal Content (image) */
    .modal-content {
        margin: auto;
        display: block;
        width: auto;
        max-height: 80vh;
    }

    /* Caption of Modal Image */
    #caption {
        margin: auto;
        display: block;
        width: 80%;
        max-width: 700px;
        text-align: center;
        color: #ccc;
        padding: 10px 0;
        height: 150px;
    }

    /* Add Animation */
    .modal-content, #caption {
        -webkit-animation-name: zoom;
        -webkit-animation-duration: 0.6s;
        animation-name: zoom;
        animation-duration: 0.6s;
    }

    @-webkit-keyframes zoom {
        from {
            -webkit-transform: scale(0)
        }
        to {
            -webkit-transform: scale(1)
        }
    }

    @keyframes zoom {
        from {
            transform: scale(0)
        }
        to {
            transform: scale(1)
        }
    }

    /* The Close Button */
    .close {
        position: absolute;
        top: 15px;
        right: 35px;
        color: white;
        font-size: 40px;
        font-weight: bold;
        transition: 0.3s;
        opacity: 1;
    }

    .close:hover,
    .close:focus {
        color: #007aff;
        text-decoration: none;
        cursor: pointer;
        opacity: 1;
    }

    /* 100% Image Width on Smaller Screens */
    @media only screen and (max-width: 700px) {
        .modal-content {
            width: 100%;
        }
    }
    @media screen and (max-width: 991px) {
        #gallery {
            padding-top: 1em;
        }
        .itemGallery {
            padding-top: 1em;
        }
    }
    /*RESPONSIVE ARROW*/
    @media screen and (max-width: 991px) {
        #Arrow {
            display: none;
        }
    }
</style>